import * as Select from '@radix-ui/react-select'
import { ChevronDown, X } from 'lucide-react'
import { useState } from 'react'
import { Button } from './Button'

interface Option {
	icon?: string // Optional icon
	text: string
	value: string
}

interface CustomSelectProps {
	options: Option[] // Pass any list of options
	value: string
	onChange: (value: string) => void
	placeholder?: string // Optional placeholder
	index?: number
	disabled?: boolean
}

const CustomSelect = ({ options, value, onChange, placeholder = 'Select an option', disabled }: CustomSelectProps) => {
	const [customInput, setCustomInput] = useState('') // Initialize custom input with the current value
	const [isInputVisible, setIsInputVisible] = useState(false) // State to toggle between select and input
	const [answerOptions, setAnswerOptions] = useState<Option[]>(options) // Store the list of answer options

	const handleSetAnswer = () => {
		if (customInput.trim() !== '') {
			const newOption = { icon: '/images/custom-answer.webp', text: customInput, value: customInput }
			setAnswerOptions(prevOptions => [...prevOptions, newOption]) // Add custom input to the options array
			onChange(customInput) // Set the custom input value to the select
			setIsInputVisible(false) // Hide input after setting the value
		}
	}

	return (
		<div className="flex flex-col gap-2 w-full">
			<Select.Root
				disabled={disabled}
				value={value}
				onValueChange={newValue => {
					if (newValue === 'custom') {
						setIsInputVisible(true) // Show input when "Custom answer" is selected
					} else {
						onChange(newValue) // Update value when a predefined option is selected
					}
				}}
			>
				<Select.Trigger className="flex justify-between items-center px-4 py-2 border border-neutral-50 rounded-lg bg-white shadow-sm cursor-pointer">
					<Select.Value placeholder={placeholder} />
					<Select.Icon className="ml-1">
						<ChevronDown />
					</Select.Icon>
				</Select.Trigger>

				<Select.Portal>
					<Select.Content className="z-50 bg-white border border-neutral-50 shadow-md rounded-lg mt-1 w-full">
						<Select.Viewport className="p-2">
							{answerOptions.map((option, index) => (
								<Select.Item
									key={index}
									value={option.value}
									className="flex items-center gap-2 px-4 py-2 rounded-md hover:bg-gray-100 cursor-pointer"
								>
									{option.icon && <img src={option.icon} alt="" className="w-5 h-5" />}
									<Select.ItemText>{option.text}</Select.ItemText>
								</Select.Item>
							))}
							<Select.Item
								value="custom"
								className="flex items-center gap-2 px-4 py-2 rounded-md hover:bg-gray-100 cursor-pointer"
							>
								<img src="/images/custom-answer.webp" alt="" className="w-5 h-5" />
								<Select.ItemText>Other</Select.ItemText>
							</Select.Item>
						</Select.Viewport>
					</Select.Content>
				</Select.Portal>
			</Select.Root>

			{/* Show input field when "Custom answer" is selected */}
			{isInputVisible && (
				<div className="flex flex-col gap-2 mt-2">
					<input
						type="text"
						value={customInput}
						onChange={e => setCustomInput(e.target.value)} // Update custom input value
						placeholder="Enter your custom answer..."
						className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm"
					/>
					{/* <button
            onClick={handleSetAnswer}
            // Add custom answer to the list and set it in select
            className="px-4 py-2 bg-blue-500 text-white rounded-lg mt-2"
          >
            Set Answer
          </button> */}
					<Button
						onClick={handleSetAnswer}
						variant="success"
						className="px-4 py-2 leading-none text-white rounded-lg mt-2"
					>
						Add Custom Option
					</Button>
				</div>
			)}
		</div>
	)
}

export default CustomSelect
